
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/terms-of-service",
      function () {
        return require("private-next-pages/legal/terms-of-service.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/terms-of-service"])
      });
    }
  